module.exports = __webpack_public_path__ + "img/licaidingdan.df3889a6.png";